import api from '@/services/utils/apiInstance'

class SerialNumberService {
  async getPaginatedSerialNumberList(search, sort, order, page, limit, subCategoryId) {
    const url =
      '/admin/serial-number/sub-category/' +
      subCategoryId +
      '/list' +
      '?search=' +
      encodeURIComponent(search) +
      '&sort=' +
      sort +
      '&order=' +
      order +
      '&page=' +
      page +
      '&limit=' +
      limit
    const response = await api.get(url)
    return response.data
  }

  async getAvailableTypeListBySubCategory(subCategoryId) {
    const response = await api.get(
      '/admin/serial-number/available-types/sub-category/' + subCategoryId
    )
    return response.data
  }

  async createModelSerialNumber(data) {
    const response = await api.post('/admin/serial-number', data)
    return response.data
  }

  async updateModelSerialNumber(data, modelSerialNumberId) {
    const response = await api.put(`/admin/serial-number/${modelSerialNumberId}`, data)
    return response.data
  }

  async getModelSerialNumber(modelSerialNumberId) {
    const response = await api.get('/admin/serial-number/' + modelSerialNumberId)
    return response.data
  }

  async getProductTypeBySubCategory(subCategoryId) {
    const response = await api.get('/admin/serial-number/by-sub-category-id/' + subCategoryId)
    return response.data
  }
}

export default new SerialNumberService()
